import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Award, Briefcase, Heart } from 'lucide-react';

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="section-padding">
      <div className="container">
        <h2 className="heading-1 section-title">{t.about.title}</h2>
        
        <div className="grid-two-column">
          <div className="about-content">
            <p className="body-large">{t.about.text}</p>
          </div>
          
          <div className="about-stats">
            <div className="stat-card">
              <Award size={32} strokeWidth={1} />
              <h3 className="heading-3">{t.about.experience}</h3>
            </div>
            <div className="stat-card">
              <Briefcase size={32} strokeWidth={1} />
              <h3 className="heading-3">{t.about.cases}</h3>
            </div>
            <div className="stat-card">
              <Heart size={32} strokeWidth={1} />
              <h3 className="heading-3">{t.about.approach}</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;